import React from 'react'
import {createRoot} from 'react-dom/client';
import BaseComponent, {
	AjaxParam,
} from '@components/base/BaseComponent/BaseComponent'
import styles from './PageShopikoOrderFree.scss'
import Loading from '../../common/primitives/Loading'
import {__t} from '../../common/lang/text-resource';
import whiteBox from "../../common/scss/WhiteBox.scss";
import ComponentSASSBreadcrumb from "../../components/ComponentSASSBreadcrumb/ComponentSASSBreadcrumb";
import {ContextSASSLoginProvider} from "../../context/ContextSASSLoginProvider";
import ComponentSASSLogin from "../../components/ComponentSASSLogin/ComponentSASSLogin";
import {ContextServicePriceProvider} from "@contexts/ContextServicePriceProvider";
import Header from "@components/base/Header/Header";
import SasSOrderPageHeaderData from "@components/base/Header/data/SasSOrderPageHeaderData";
import MenuBottom from "@components/base/MenuBottom/MenuBottom";
import {ContextNotificationProvider, notify} from "@contexts/ContextNotificationProvider";

class PageShopikoOrderFree extends BaseComponent {

	lang = 'bg'

	constructor() {
		super(...arguments, 'PageShopikoOrderFree');
		this.lang = SHVO.pageLang ?? 'bg';
	}

	render() {
		if (this.loading) {
			return (
			  <div
				data-layout='center row middle gutter-none'
				className={styles.loading}
			  >
				  <div data-layout='col 12'>
					  <Loading loadingText={__t('Зареждане...')}/>
				  </div>
			  </div>
			)
		}

		const {contextSASSLogin, disabled, maxTrialShops} = this.props.data.componentData;

		return (
		  <>
			  <ContextNotificationProvider>
				  <ContextServicePriceProvider>
					  <Header data={SasSOrderPageHeaderData}/>
				  </ContextServicePriceProvider>
				  <ContextSASSLoginProvider sessionKey="ShopikoSessionVOKey" data={contextSASSLogin}>
					  <section role="main">
						  <div className={styles.introContainer}>
							  <div className={`${whiteBox.container} ${styles.intro}`}>
								  <ComponentSASSBreadcrumb activeStep={1}/>
								  {!disabled && <ComponentSASSLogin/>}
								  {!!disabled && (
									<div className={styles.disabledTrial}>
										{__t('достигнахте-максималния-брой-тестови-магазини-fkwef0534', {max: maxTrialShops ?? 5})}
										{/*<br/>*/}
										{/*<br/>*/}
										{/*{__t('веднага-след-като-e-създаден-данните-за-вход-в-ад67a9c0')}*/}
									</div>
								  )}
							  </div>
						  </div>
					  </section>
				  </ContextSASSLoginProvider>

				  <MenuBottom color={'color-brand-orange-400'}/>
			  </ContextNotificationProvider>
		  </>
		)
	}
}

const container = document.getElementById(SHVO.pageAppId);
const root = createRoot(container);
root.render(<PageShopikoOrderFree data={SHVO.pageState}/>);